export default {
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: '15px 35px'
  },
  form: {
    display: 'flex',
    justifyContent: 'flex-start',
    width: '100%'
  }
};
